<template>
  <td class="day" :data-yc-value="date">
    <span :class="{ 'current-day': currentDay }">{{ dayOfMonth }}</span>
    <div
      class="have-appointment-wrapper"
      v-if="
        selectedProviderID in appointmentDates &&
          appointmentDates[selectedProviderID].indexOf(date) !== -1
      "
    >
      <span class="have-appointment"></span>
    </div>
    <div class="have-appointment-wrapper" v-else>
      <span class="have-no-appointment"></span>
    </div>
  </td>
</template>

<script>
import { dayMixin } from "../../../mixins/dayMixin.js";

export default {
  mixins: [dayMixin],
  props: {
    fetchAppointmentDetails: Boolean
  }
};
</script>

<style scoped>
span {
  cursor: pointer;
}
span.current-day {
  background-color: #d26d13;
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: inline-block;
  line-height: 15px;
}

span.have-appointment {
  width: 3px;
  height: 3px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
}

span.have-no-appointment {
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
}
</style>
